import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { BILLING_CLASS_LABEL, CHANGE_STAGE_LABEL } from '@veta-desk/domain';
import { api, ApiError, type ChangeDetail } from '../lib/api';

/** En el ticket REQ con Veta Change: resumen del cambio y liga. Si el REQ sigue el flujo básico, muestra el respaldo. */
export function ChangeCard({ number, fallback }: { number: string; fallback: ReactNode }) {
  const q = useQuery({ queryKey: ['change', number], queryFn: () => api<ChangeDetail>(`/change/${number}`), retry: false });
  if (q.error instanceof ApiError && q.error.code === 'BASIC_FLOW') return <>{fallback}</>;
  if (q.isLoading) return <p className="text-sm text-muted">Cargando…</p>;
  if (!q.data) return <p className="text-sm text-muted">No se pudo cargar el cambio.</p>;
  const d = q.data;
  return (
    <div className="flex flex-col gap-2 text-sm">
      <p><span className="rounded-full bg-accent-soft px-2 py-0.5 text-xs font-semibold text-accent-dark">{CHANGE_STAGE_LABEL[d.stage]}</span></p>
      {d.delivery?.commitment && d.stage !== 'closed' && (
        <p className="text-xs text-muted">
          Fecha compromiso: {Math.round(d.delivery.commitment.pct * 100)} % de {d.delivery.commitment.businessDays} días hábiles
          {d.delivery.commitment.health === 'paused' ? ' · en pausa' : d.delivery.commitment.health === 'late' ? ' · vencida' : ''}
        </p>
      )}
      {d.permissions.deliver && <p className="text-xs text-muted">Las pruebas del usuario, el paso a producción y el cierre se hacen en el cambio.</p>}
      {d.versions[0] ? (
        <p><span className="font-mono text-2xl font-semibold">{d.versions[0].consultantTotal} h</span>
          <span className="ml-2 text-xs text-muted">estimación v{d.versions[0].version} · preliminar: {BILLING_CLASS_LABEL[d.versions[0].preliminaryClass].toLowerCase()}</span></p>
      ) : <p className="text-muted">{d.totals.total ? `Borrador: ${d.totals.total} h` : 'Sin estimación todavía.'}</p>}
      <Link to={`/cambios/${number}`} className="inline-flex h-9 w-fit items-center rounded-md bg-accent px-4 text-sm font-semibold text-white hover:bg-accent-dark">
        {d.permissions.estimate ? 'Estimar en Veta Change' : 'Ver el cambio'}
      </Link>
    </div>
  );
}
